<template>
  <body class="contents">
  <div class="head">
    <div class="head-top">
      <div class="title">购销订单系统</div>
    </div>
  </div>
  <div class="contents-body">
    <div class="head-login">
      <div class="login">
        <div style="width: 22%;">账号：</div>
        <div><input type="text" v-model="form.account" placeholder="请输入新账号" class="app-input" /></div>
      </div>
      <div class="login">
        <div style="width: 22%;">新密码：</div>
        <div><input type="text" v-model="form.password" placeholder="请输入新账号" class="app-input" /></div>
      </div>
      <div class="login">
        <div style="width: 22%;">确认密码：</div>
        <div><input type="password" v-model="form.confirmPassword" placeholder="请输入确认密码" class="app-input" /></div>
      </div>
    </div>
    <div class="sign-in">
      <el-button class="logins" type="primary" @click="submit">确认修改</el-button>
    </div>
  </div>
  </body>
</template>

<script>

export default {
  name: 'Password',
  data () {
    return {
      form: {
        account: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    submit () {
      try {
        if (this.form.password === '' || this.form.password === '123456') {
          this.msgInfo('新密码过于简单,请重新输入')
          return
        }
        if (this.form.password !== this.form.confirmPassword) {
          this.msgInfo('新密码和确认密码不同,请重新输入')
          return
        }
        this.$api.password(this.form).then(response => {
          if (response.code === 200) {
            this.$router.push({ name: 'Login' })
          } else {
            this.msgError('修改密码失败,请重试...')
          }
        })
      } catch (error) {
        console.error('Login error:', error)
      }
    }
  }
}
</script>

<style scoped>
.contents{
  width: 100%;
  height: 100vh;
  background-color: #f3efde;
  font-size: 14px;
  line-height: 1.8;
}

.head{
  display: flex;
  height: 175px;
}

.head-top{
  margin: auto;
}

.title{
  font-size: 22px;
  color: #b58c5a;
  font-weight: 600;
}

.head-login {
  margin-top: 25px;
}

.login {
  display: flex;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  width: 80%;
  margin: 10px auto 0;
  background-color: #e0d4bb;
}

.login>div {
  font-size: 15px;
  margin: 9px 0 0 15px;
  line-height: 1.8;
  display: block;
}

.login>div input {
  margin-top: 2px;
  display: block;
  font-size: 16px;
  line-height: 1.4em;
  height: 1.4em;
  min-height: 1.4em;
  overflow: hidden;
}

.app-input{
  background-color: initial;
  color: inherit;
  text-shadow: inherit;
  outline-color: initial;
  border-color: initial;
  text-decoration-color: inherit;
  position: relative;
  display: block;
  height: 100%;
  background: none;
  opacity: 1;
  font: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-indent: inherit;
  text-transform: inherit;
  width: 100%;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  text-decoration: inherit;
}

.remember-password{
  width: 80%;
  margin: auto;
}

.remember-password div{
  margin-left: 15px;
  line-height: 50px;
}

.sign-in .el-button {
  width: 70%;
  border-radius: 15px !important;
  border: none;
  color: #fff;
  font-weight: 600;
  line-height: 1.3;
  font-size: 18px;
}

.logins {
  margin: 10px auto;
  background-color: #f0b78e !important;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/Password.vue